// Vendor JS
import 'bootstrap/dist/js/bootstrap.min.js';
import AOS from 'aos';
import GLightbox from 'glightbox';
import PureCounter from '@srexi/purecounterjs';
import Flickity from 'flickity';
import Swiper from 'swiper/bundle';
import moment from 'moment';

// Vendors CSS
import 'modern-normalize/modern-normalize.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'aos/dist/aos.css';
import 'glightbox/dist/css/glightbox.min.css';
import 'bootstrap-icons/font/bootstrap-icons.min.css';
import 'flickity/css/flickity.css';
import 'swiper/css/bundle';

// Styles
import '../scss/base.scss';

(function () {
    'use strict';

    /**
     * Apply .scrolled class to the body as the page is scrolled down
     */
    function toggleScrolled () {
        const selectBody = document.querySelector('body');
        const selectHeader = document.querySelector('#header');
        if (!selectHeader.classList.contains('scroll-up-sticky') && !selectHeader.classList.contains('sticky-top') && !selectHeader.classList.contains('fixed-top')) return;
        window.scrollY > 100 ? selectBody.classList.add('scrolled') : selectBody.classList.remove('scrolled');
    }

    document.addEventListener('scroll', toggleScrolled);
    window.addEventListener('load', toggleScrolled);

    /**
     * Mobile nav toggle
     */
    const mobileNavToggleBtn = document.querySelector('.mobile-nav-toggle');

    function mobileNavToogle () {
        document.querySelector('body').classList.toggle('mobile-nav-active');
        mobileNavToggleBtn.classList.toggle('bi-list');
        mobileNavToggleBtn.classList.toggle('bi-x');
    }

    if (mobileNavToggleBtn) {
        mobileNavToggleBtn.addEventListener('click', mobileNavToogle);
    }

    /**
     * Hide mobile nav on same-page/hash links
     */
    document.querySelectorAll('#navmenu a').forEach(navmenu => {
        navmenu.addEventListener('click', () => {
            if (document.querySelector('.mobile-nav-active')) {
                mobileNavToogle();
            }
        });

    });

    /**
     * Toggle mobile nav dropdowns
     */
    document.querySelectorAll('.navmenu .toggle-dropdown').forEach(navmenu => {
        navmenu.addEventListener('click', function (e) {
            e.preventDefault();
            this.parentNode.classList.toggle('active');
            this.parentNode.nextElementSibling.classList.toggle('dropdown-active');
            e.stopImmediatePropagation();
        });
    });

    /**
     * Scroll top button
     */
    let scrollTop = document.querySelector('.scroll-top');

    function toggleScrollTop () {
        if (scrollTop) {
            window.scrollY > 100 ? scrollTop.classList.add('active') : scrollTop.classList.remove('active');
        }
    }

    scrollTop.addEventListener('click', (e) => {
        e.preventDefault();
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    });

    window.addEventListener('load', toggleScrollTop);
    document.addEventListener('scroll', toggleScrollTop);

    /**
     * Animation on scroll function and init
     */
    function aosInit () {
        AOS.init({
            duration: 600,
            easing: 'ease-in-out',
            once: true,
            mirror: false
        });
    }

    window.addEventListener('load', aosInit);

    /**
     * Initiate glightbox
     */
    const glightbox = GLightbox({
        selector: '.glightbox'
    });

    /**
     * Initiate Pure Counter
     */
    new PureCounter();

    /**
     * Frequently Asked Questions Toggle
     */
    document.querySelectorAll('.faq-item h3, .faq-item .faq-toggle').forEach((faqItem) => {
        faqItem.addEventListener('click', () => {
            faqItem.parentNode.classList.toggle('faq-active');
        });
    });

    /**
     * Init isotope layout and filters
     */
    // document.querySelectorAll('.isotope-layout').forEach(function (isotopeItem) {
    //   let layout = isotopeItem.getAttribute('data-layout') ?? 'masonry';
    //   let filter = isotopeItem.getAttribute('data-default-filter') ?? '*';
    //   let sort = isotopeItem.getAttribute('data-sort') ?? 'original-order';
    //
    //   let initIsotope;
    //   imagesLoaded(isotopeItem.querySelector('.isotope-container'), function () {
    //     initIsotope = new Isotope(isotopeItem.querySelector('.isotope-container'), {
    //       itemSelector: '.isotope-item',
    //       layoutMode: layout,
    //       filter: filter,
    //       sortBy: sort
    //     });
    //   });
    //
    //   isotopeItem.querySelectorAll('.isotope-filters li').forEach(function (filters) {
    //     filters.addEventListener('click', function () {
    //       isotopeItem.querySelector('.isotope-filters .filter-active').classList.remove('filter-active');
    //       this.classList.add('filter-active');
    //       initIsotope.arrange({
    //         filter: this.getAttribute('data-filter')
    //       });
    //       if (typeof aosInit === 'function') {
    //         aosInit();
    //       }
    //     }, false);
    //   });
    //
    // });

    /**
     * Init swiper sliders
     */
    function initSwiper () {
        document.querySelectorAll('.init-swiper').forEach(function (swiperElement) {
            let config = JSON.parse(
                swiperElement.querySelector('.swiper-config').innerHTML.trim()
            );

            if (swiperElement.classList.contains('swiper-tab')) {
                initSwiperWithCustomPagination(swiperElement, config);
            } else {
                new Swiper(swiperElement, config);
            }
        });
    }

    window.addEventListener('load', initSwiper);

    /**
     * Correct scrolling position upon page load for URLs containing hash links.
     */
    window.addEventListener('load', function (e) {
        if (window.location.hash) {
            if (document.querySelector(window.location.hash)) {
                setTimeout(() => {
                    let section = document.querySelector(window.location.hash);
                    let scrollMarginTop = getComputedStyle(section).scrollMarginTop;
                    window.scrollTo({
                        top: section.offsetTop - parseInt(scrollMarginTop),
                        behavior: 'smooth'
                    });
                }, 100);
            }
        }
    });

    /**
     * Navmenu Scrollspy
     */
    let navmenulinks = document.querySelectorAll('.navmenu a');

    function navmenuScrollspy () {
        navmenulinks.forEach(navmenulink => {
            if (!navmenulink.hash) return;
            let section = document.querySelector(navmenulink.hash);
            if (!section) return;
            let position = window.scrollY + 200;
            if (position >= section.offsetTop && position <= (section.offsetTop + section.offsetHeight)) {
                document.querySelectorAll('.navmenu a.active').forEach(link => link.classList.remove('active'));
                navmenulink.classList.add('active');
            } else {
                navmenulink.classList.remove('active');
            }
        });
    }

    window.addEventListener('load', navmenuScrollspy);
    document.addEventListener('scroll', navmenuScrollspy);


    let options = {
        accessibility: true,
        prevNextButtons: true,
        pageDots: true,
        setGallerySize: false,
        arrowShape: {
            x0: 10,
            x1: 60,
            y1: 50,
            x2: 60,
            y2: 45,
            x3: 15
        }
    };

    let carousel = document.querySelector('[data-carousel]');
    if (carousel) {
        let slides = document.getElementsByClassName('carousel-cell');
        let flkty = new Flickity(carousel, options);

        flkty.on('scroll', function () {
            flkty.slides.forEach(function (slide, i) {
                let image = slides[i];
                let x = (slide.target + flkty.x) * -1 / 3;
                image.style.backgroundPosition = x + 'px';
            });
        });
    }

    if (document.querySelector('[data-load-news]')) {
        window.addEventListener('load', (e) => {
            fetch('https://graph.facebook.com/v22.0/562939826892804/published_posts?fields=message%2Cmessage_tags%2Ccreated_time%2Cvideo_buying_eligibility%2Cpermalink_url%2Cfull_picture%2Cthumbnails&access_token=EAAc4uMoqyoYBO3ANm3AtFR8DJMomemLiC55ZAjm9O9fa4zUVP3RMmlsUEf3ppBKzRAl2S3ZChRQlgWte7HGrZAmLem1skgM5wz9BDLWSl8hPyPWqPYcsDZCDoSHeyyWZCpamgDyo73PblJM4chM36ZAiZAzrjgDwtYmV2W8Mm4OiQWzWwlMTFDyrZCcdUNdfZCa5o7lSi6ofeZBB3FUBaH') // api for the get request
                .then(response => response.json())
                .then(data => {
                    document.querySelector('[data-load-news] .posts-loading').remove();

                    const content = data.data;

                    console.log(content);
                    for (let i = 0; i < content.length; i++) {
                        if (content[i].message) {
                            let imgSrc = '/assets/img/post-placeholder.jpg';
                            let mainContent = content[i].message;
                            let readMoreText = 'Read More';
                            let readLessText = 'Read Less';

                            if (content[i].full_picture) {
                                imgSrc = content[i].full_picture;
                            }

                            if (content[i].message.length > 400) {
                                readMoreText = document.querySelector('[data-load-news]').getAttribute('data-read-more-text');
                                readLessText = document.querySelector('[data-load-news]').getAttribute('data-read-less-text');
                                mainContent = content[i].message.substr(0, 400) + '... ' + `<a onclick="this.parentElement.style.display = 'none';this.parentElement.nextElementSibling.style.display = 'block';" href="javascript:void(0)">${readMoreText}</a>`;
                                const fullContent = content[i].message + ` <a onclick="this.parentElement.style.display = 'none';this.parentElement.previousElementSibling.style.display = 'block';" href="javascript:void(0)">${readLessText}</a>`;

                                document.querySelector('[data-load-news] .row').innerHTML += `
                                <div class="col-12 mb-4" data-post-id="${content[i].id}">
                                    <div class="ud-single-blog">
                                        <div class="ud-blog-image">
                                            <a href="${content[i].permalink_url}" target="_blank">
                                                <img src="${imgSrc}" alt="${content[i].permalink_url}" />
                                            </a>
                                        </div>
                                        <div class="ud-blog-content">
                                            <span class="ud-blog-date">${moment(content[i].created_time).format('LL')}</span>
                                            <p class="ud-blog-desc">
                                                ${mainContent}
                                            </p>
                                            <p class="ud-blog-desc full" style="display: none">
                                                ${fullContent}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                               `;
                            } else {
                                document.querySelector('[data-load-news] .row').innerHTML += `
                                <div class="col-12 mb-4" data-post-id="${content[i].id}">
                                    <div class="ud-single-blog">
                                        <div class="ud-blog-image">
                                            <a href="${content[i].permalink_url}" target="_blank">
                                                <img src="${imgSrc}" alt="${content[i].permalink_url}" />
                                            </a>
                                        </div>
                                        <div class="ud-blog-content">
                                            <span class="ud-blog-date">${moment(content[i].created_time).format('LL')}</span>
                                            <p class="ud-blog-desc">
                                                ${mainContent}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                `;
                            }
                        }
                    }
                });
        });
    }
})();
